import { NgModule } from '@angular/core';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
} from '@angular/platform-browser';
import { RouterModule, UrlSerializer } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import {
  StoreRouterConnectingModule,
  DefaultRouterStateSerializer,
} from '@ngrx/router-store';
import 'hammerjs';
import { LowerCaseUrlSerializer, ROUTES } from './app.routes';
import { environment } from '../environments';
import { LocalizationModule, TRANSLATE_LOADER } from '../localization';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import * as fromGuards from './guards';
import * as fromStore from './store';
import * as fromServices from '../app/services';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';
import { TrackingModule } from '../tracking/tracking.module';
import { AccountModule } from '../account';
import { I2gNgUiModule } from 'i2g-ng-ui';

export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    pinch: { enable: false },
    rotate: { enable: false },
  };
}

@NgModule({
  declarations: [...fromComponents.components, ...fromContainers.containers],
  imports: [
    BrowserModule,
    HttpClientModule,
    StoreModule.forRoot(fromStore.reducers),
    // Instrumentation must be imported after importing StoreModule (config is optional)
    environment.debugMode ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forRoot([...fromStore.effects]),
    RouterModule.forRoot(ROUTES),
    TranslateModule.forRoot(TRANSLATE_LOADER),
    AccountModule.forRoot(),
    LocalizationModule.forRoot(),
    StoreRouterConnectingModule.forRoot({
      serializer: DefaultRouterStateSerializer,
    }),
    TrackingModule.forRoot(),
    I2gNgTrackingModule.forRoot(),
    I2gNgUiModule,
  ],
  providers: [
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
    ...fromGuards.guards,
    ...fromStore.dispatchers,
    ...fromStore.stores,
    ...fromServices.services,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
  ],
  bootstrap: [fromContainers.AppComponent],
})
export class AppModule {}
